export default __webpack_public_path__ + "static/media/ba4.e32ea6ea.jpg";